import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Badge, BadgeService } from '@services/badge.service';
import { BadgeEditComponent } from '../badge-edit/badge-edit.component';

@Component({
  selector: 'app-badge-list',
  templateUrl: './badge-list.component.html'
})
export class BadgeListComponent implements OnInit {
  badges: Badge[] = [];
  loading = false;

  constructor(
    private badgeService: BadgeService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.loadBadges();
  }

  loadBadges(): void {
    this.loading = true;
    this.badgeService.getAll().subscribe(
      (data) => {
        this.badges = data;
        this.loading = false;
      },
      () => {
        this.toastr.error('Rozetler yüklenirken hata oluştu', 'Hata');
        this.loading = false;
      }
    );
  }

  openCreateModal(): void {
    const modalRef = this.modalService.open(BadgeEditComponent, { size: 'md', backdrop: 'static' });
    modalRef.componentInstance.isEditMode = false;
    modalRef.result.then(
      (result) => { if (result) this.loadBadges(); },
      () => {}
    );
  }

  openEditModal(badge: Badge): void {
    const modalRef = this.modalService.open(BadgeEditComponent, { size: 'md', backdrop: 'static' });
    modalRef.componentInstance.isEditMode = true;
    modalRef.componentInstance.badge = { ...badge };
    modalRef.result.then(
      (result) => { if (result) this.loadBadges(); },
      () => {}
    );
  }

  delete(badge: Badge): void {
    if (confirm(`"${badge.name}" rozetini silmek istediğinize emin misiniz?`)) {
      this.badgeService.delete(badge.id).subscribe(
        () => {
          this.toastr.success('Rozet başarıyla silindi', 'Başarılı');
          this.loadBadges();
        },
        () => this.toastr.error('Rozet silinirken hata oluştu', 'Hata')
      );
    }
  }
}
